import comp from "./OrganizationList";
export default comp;
